import { render, staticRenderFns } from "./EditCustomer.vue?vue&type=template&id=4f2c07fc&scoped=true&"
import script from "./EditCustomer.vue?vue&type=script&lang=js&"
export * from "./EditCustomer.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomer.vue?vue&type=style&index=0&id=4f2c07fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c07fc",
  null
  
)

export default component.exports